import { useNavigate } from 'react-router-dom';
import { pathRegistery } from '../routes/route-path';
import { AuthUser, UserRole } from '../types/auth';
import useAuth from './useAuth';

const useAuthSession = () => {
  const { signIn: signInSession, signOut: signOutSession } = useAuth();
  const navigate = useNavigate();

  const redirectRoute = () => {
    const localUser = localStorage.getItem('user');
    const userLocalStorage = localUser ? (JSON.parse(localUser) as AuthUser) : null;

    const role = userLocalStorage?.role?.role;

    if (!role) {
      return pathRegistery.signIn;
    }

    if (role === UserRole.SUPER_ADMIN) {
      return pathRegistery.adminSignIn;
    } else if (role === UserRole.EMPLOYEE) {
      return pathRegistery.employeeSignIn;
    } else {
      return pathRegistery.signIn;
    }
  };

  const signIn = (user: AuthUser, navigateTo?: string) => {
    signInSession(user, navigateTo);

    let redirectLink = '/dashboard';

    // Determine redirect link based on role, this can be customized further
    if (user?.role?.role === UserRole.EMPLOYEE) {
      redirectLink = '/employee'; // Specific employee dashboard
    }
    // You might want to use navigateTo if provided, otherwise default based on role
    navigate(navigateTo ?? redirectLink, { replace: true });
  };

  const signOut = () => {
    const redirectUrl = redirectRoute();

    signOutSession();

    navigate(redirectUrl, { replace: true });

    if (redirectUrl === pathRegistery.employeeSignIn) {
      window.location.reload();
    }
  };

  return {
    signIn,
    signOut,
  };
};

export default useAuthSession;
